/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import Grid from '@material-ui/core/Grid';

import BackButton from './BackButton';
import Spinner from '../assets/svg/Spinner';
import CUSTOM_BREAKPOINTS from '../style/customBreakpoints';

const mobileLoading = (pageTitle, url) => (
    <>
        {pageTitle ? (
            <h1>
                <BackButton url={url || ''} />
                {pageTitle}
            </h1>
        ) : (
            ''
        )}
        <div className="spinner">
            <Spinner />
        </div>
    </>
);

const desktopLoading = (pageTitle) => (
    <>
        <Grid className="container" container>
            <Grid item xs={2} />
            <Grid className="loading-screen" item xs={10}>
                {pageTitle ? (
                    <h2 className="display-none">
                        {pageTitle}
                    </h2>
                ) : (
                    ''
                )}
            </Grid>
            <div className="spinner">
                <Spinner desktop />
            </div>
        </Grid>
    </>
);

const Loading = ({ pageTitle, url }) => {
    const breakpointExpr = `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
    return (
        <>
            <Media query={breakpointExpr}>
                {(matches) => (matches ? mobileLoading(pageTitle, url) : desktopLoading(pageTitle))}
            </Media>
        </>
    );
};

Loading.defaultProps = {
    url: '',
    pageTitle: '',
};

Loading.propTypes = {
    url: PropTypes.string,
    pageTitle: PropTypes.string,
};

export default Loading;
